import get from 'lodash/fp/get';
import includes from 'lodash/fp/includes';
import merge from 'lodash/fp/merge';

import { detectFeatureToggles } from './setup/featureToggles';

import { localAuthConfig } from './env/env.localauth';
import { localConfig } from './env/env.local';
import { localProdConfig } from './env/env.localprod';
import { productionConfig } from './env/env.production';
import { productionLATAMConfig } from './env/env.production.latam';
import { testConfig } from './env/env.test';

export const getConfig = get('config');

export const getLoginClientId = get('config.login.clientId');

export const getLoginRedirectUri = get('config.login.redirectUri');

export const getUserSettingsBackend = get('config.backend.USER_SETTINGS_SERVICE');

export const getProdEnvironment = host => {
    if (includes('admin-latam', host)) {
        return productionLATAMConfig;
    }
    return productionConfig;
};
export const isProdEnvironment = host => {
    return includes('admin', host);
};

export const getRuntimeConfig = (window, env = {}) => {
    const host = window.location.host;
    const defaultConfig = {
        backend: {},
        homeRoute: `${window.location.origin}`,
        id: 'env.stub',
        login: {
            clientId: 'eqKXJPzwtz7lhMSjfvbdYtt4MC4a',
            oauthScope: [
                'openid',
                'profile',
                'email',
            ],
            mockLocale: 'en-GB',
            preventRedirect: false,
        },
        sentryToken: 'https://33c3dc0e13e74e24a43341cb47b2e50d@sentry.io/1730928',
    };

    let config = localConfig;

    if (env.isRunningOnProd) {
        config = getProdEnvironment(host);
    }
    if (env.featureToggles.enforcedEnv === 'localauth') {
        config = localAuthConfig;
    }
    if (env.featureToggles.enforcedEnv === 'localprod') {
        config = localProdConfig;
    }
    if (env.featureToggles.enforcedEnv === 'production') {
        config = getProdEnvironment(host);
    }
    if (env.isTestEnv) {
        config = testConfig;
    }

    return merge(merge({}, defaultConfig), config);
};

export const configureEnv = (window, process) => {
    const { location: { host } } = window;
    const { env: { NODE_ENV } } = process;

    // TODO: Change the URLs to the ones your service is using
    const isProdEnv = isProdEnvironment(host);
    const isStagingEnv = isProdEnvironment(host);
    const isTestEnv = NODE_ENV === 'test';
    const isLocalEnv = !isProdEnv && !isStagingEnv && !isTestEnv;

    const shouldSendMetrics = isProdEnv || isStagingEnv;

    const isProdBuild = NODE_ENV === 'production';
    const isRunningOnProd = isProdEnvironment(host);
    const isRunningOnStaging = isProdEnvironment(host);
    const runsInSandbox = isProdBuild && !isRunningOnStaging && !isRunningOnProd;

    const shouldRestrictLog = NODE_ENV === 'production';
    const shouldUseConsoleLogger = false; //NODE_ENV !== 'test' && !shouldRestrictLog;

    const featureToggles = detectFeatureToggles(window);

    const env = {
        featureToggles,
        isLocalEnv,
        isProdBuild,
        isRunningOnProd,
        isRunningOnStaging,
        isTestEnv,
        runsInSandbox,
        runtimeConfig: {},
        shouldRestrictLog,
        shouldUseConsoleLogger,
        shouldSendMetrics,
    };

    env.runtimeConfig = getRuntimeConfig(window, env);

    return env;
};

export const env = configureEnv(window, process);

if (env.featureToggles.tracing) {
    // eslint-disable-next-line no-console
    console.log(env);
}
